export const PORTAL_CAPABILITIES = [
  "manage_users",
  "site_admin",
  "tasks",
  "branch_profile",
  "branch_news",
  "branch_projects",
  "batch_profile",
  "batch_news",
  "batch_projects",
  "association_profile",
  "association_news",
  "association_projects",
] as const;

export type PortalCapability = (typeof PORTAL_CAPABILITIES)[number];

/** One row in `portal_access_grants`. */
export type PortalGrantRow = {
  id: string;
  email: string;
  capability: PortalCapability;
  branch_id: string | null;
  batch_id: string | null;
  association_id: string | null;
  created_at: string;
};

/**
 * Synthetic workspace for scoped News/Projects (one per branch, batch, or association
 * the user has any scoped grant on).
 */
export type PortalWorkspaceRow = {
  id: string;
  kind: "branch" | "batch" | "association";
  parent_id: string;
  created_at: string;
};
